import { blue, brand, gray, green, orange, purple, red } from "./colors";
import { defaultThemeMode, isSupportedThemeMode } from "./modes";

export function createPalette(mode = defaultThemeMode) {
  const resolvedMode = isSupportedThemeMode(mode) ? mode : defaultThemeMode;

  return {
    mode: resolvedMode,
    primary: {
      light: purple[300],
      main: purple[500],
      dark: purple[700],
      contrastText: "#FFFFFF",
    },
    secondary: {
      light: purple[100],
      main: purple[600],
      dark: purple[800],
      contrastText: "#FFFFFF",
    },
    success: {
      light: green[100],
      main: green[600],
      dark: green[800],
      contrastText: "#FFFFFF",
    },
    warning: {
      light: orange[100],
      main: orange[500],
      dark: orange[700],
      contrastText: gray[900],
    },
    error: {
      light: red[100],
      main: red[600],
      dark: red[800],
      contrastText: "#FFFFFF",
    },
    info: {
      light: purple[100],
      main: purple[500],
      dark: purple[700],
      contrastText: "#FFFFFF",
    },
    grey: gray,
    divider: "rgba(82, 82, 91, 0.18)",
    background: {
      default: "#FAFAFA",
      paper: "#FFFFFF",
    },
    text: {
      primary: gray[900],
      secondary: gray[600],
      disabled: gray[400],
    },
    action: {
      hover: "rgba(129, 66, 252, 0.06)",
      selected: "rgba(129, 66, 252, 0.12)",
      disabled: gray[400],
      disabledBackground: gray[100],
    },
    custom: {
      gray,
      brand,
      blue,
      green,
      orange,
      red,
      purple,
    },
  };
}

export const palette = createPalette(defaultThemeMode);
